var Backbone = require('backbone');
var _ = require('underscore');

var Service = require('front/pages/Service/Service');

require('./UrgentSellPopup.less');

module.exports = Service.extend({
    template: require('./UrgentSellPopup.jinja'),

    el: '.UrgentSellPopup',

    apiUrl: '/api/urgent-sell',

    initialize: function (options) {
        Service.prototype.initialize.call(this, options);
    },

    render: function () {
        Service.prototype.render.call(this);
    },

    viewsRegistration: function () {
    },

    playIn: function () {
        this.$el.hide();

        return new Promise(function (resolve) {
            this.$el.fadeIn(function () {
                resolve();
            });
        }.bind(this));
    },

    playOut: function () {
        return new Promise(function (resolve) {
            this.$el.fadeOut(function () {
                resolve();
            });
        }.bind(this));
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/UrgentSell/UrgentSellPopup.js
// module id = 63
// module chunks = 0